import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthMethod} from "../../tracking/types/AmplitudeAuthMethod";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {ViewType} from "../../view_type/ViewType";

type LoginEventName = "logged_in" | "login_click" | "login_form_view";
type SignUpEventName = "signed_up" | "sign_up_click" | "sign_up_form_view";

export type AmplitudeAuthLocation = "property_page" | "investment_page" | "listing_page" | "homepage" | "rp_ai_chat" | null;

export const getAmplitudeAuthLocation = (viewType: ViewType | null): AmplitudeAuthLocation => {
    switch (viewType) {
        case ViewType.OFFER_LIST:
        case ViewType.OFFER_LIST_ABROAD:
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
        case ViewType.PROMOTION_LIST:
            return "listing_page";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.PROPERTY:
            return "property_page";
        case ViewType.HOMEPAGE:
            return "homepage";
        default:
            return null;
    }
};

interface ILoginEventParams {
    loginMethod: AmplitudeAuthMethod;
    loginPlacement: AmplitudeAuthPlacement | null;
    location?: AmplitudeAuthLocation;
}

interface ISignUpEventParams {
    signUpMethod: AmplitudeAuthMethod;
    signUpPlacement: AmplitudeAuthPlacement | null;
    location?: AmplitudeAuthLocation;
}

export const trackAmplitudeAuthEvent = (event: LoginEventName | SignUpEventName, params: ILoginEventParams | ISignUpEventParams) => {
    const location = params.location ?? null;

    if ("loginMethod" in params) {
        trackAmplitudeEvent(event, {
            login_method: params.loginMethod,
            login_placement: params.loginPlacement,
            location
        });
    } else {
        trackAmplitudeEvent(event, {
            sign_up_method: params.signUpMethod,
            sign_up_placement: params.signUpPlacement,
            location
        });
    }
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeAuthMethod} from "../../tracking/types/AmplitudeAuthMethod";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {ViewType} from "../../view_type/ViewType";

type LoginEventName = "logged_in" | "login_click" | "login_form_view";
type SignUpEventName = "signed_up" | "sign_up_click" | "sign_up_form_view";

export type AmplitudeAuthLocation = "property_page" | "investment_page" | "listing_page" | "homepage" | "rp_ai_chat" | null;

export const getAmplitudeAuthLocation = (viewType: ViewType | null): AmplitudeAuthLocation => {
    switch (viewType) {
        case ViewType.OFFER_LIST:
        case ViewType.OFFER_LIST_ABROAD:
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
        case ViewType.PROMOTION_LIST:
            return "listing_page";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.PROPERTY:
            return "property_page";
        case ViewType.HOMEPAGE:
            return "homepage";
        default:
            return null;
    }
};

interface ILoginEventParams {
    loginMethod: AmplitudeAuthMethod;
    loginPlacement: AmplitudeAuthPlacement | null;
    location?: AmplitudeAuthLocation;
}

interface ISignUpEventParams {
    signUpMethod: AmplitudeAuthMethod;
    signUpPlacement: AmplitudeAuthPlacement | null;
    location?: AmplitudeAuthLocation;
}

export const trackAmplitudeAuthEvent = (event: LoginEventName | SignUpEventName, params: ILoginEventParams | ISignUpEventParams) => {
    const location = params.location ?? null;

    if ("loginMethod" in params) {
        trackAmplitudeEvent(event, {
            login_method: params.loginMethod,
            login_placement: params.loginPlacement,
            location
        });
    } else {
        trackAmplitudeEvent(event, {
            sign_up_method: params.signUpMethod,
            sign_up_placement: params.signUpPlacement,
            location
        });
    }
};
